import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { OrganizationsProvider } from '../providers/organizations-provider';
import { Observable } from "rxjs";
import { Organization } from "../../common/models/organization";

@Injectable({providedIn: 'root'})
export class OrganizationResolver implements Resolve<Organization> {
    constructor(
        private organizationsProvider: OrganizationsProvider,
    ) { }

    public resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<Organization> {
      return this.organizationsProvider.getByCode(route.params['organizationCode']);
    }
}
